module.exports = "https://portperrypedals.ca/_res/img/rotary-cheque.7e34ac4.jpg";